<template>
  <div class="about-qualifications">
    <div class="container">
      <div class="about-subject">
        <div class="about-title">荣誉资质</div>
        <h1 class="about-text">CCTV2021年度十大艺术涂料</h1>
        <div class="about-item">
          <h1>建材行业职业能力培训基地 <br>（墙体艺术涂装师）</h1>
          <p>其他荣誉资质1</p>
          <p>其他荣誉资质2</p>
        </div>
      </div>
      <div class="about-video">
        <img src="https://img.xnxx.mengcreate.com/LJL/about5.png" alt="">
        <p>国家建筑材料行业职业技能鉴定指导中心与中国建筑装饰装修材料协会建筑涂料分会、硅藻泥分会在2020年3月共同设立了“
          墙体艺术涂装师”职业能力工种，这是适应国家稳就业政策而设立的一个新的职业能力工种，也是唯一一个针对“内墙涂装”而设立的职业工种。经国家墙体艺术涂装师职业技能评价标准编写委员会研究决定，长沙美家乐装饰材料有限公司为编写委员会编制单位。
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less'>
.about-qualifications {
  height: 750px;
  width: 100%;
  background: url(../../../assets/images/about/about4.png);
  background-size: cover;
  background-position: center;
  .container {
    display: flex;
    align-items: center;
    .about-subject {
      flex: 1;
      .about-title {
        display: inline-block;
        font-weight: 500;
        padding: 0.2rem;
        border-bottom: 1px #74b828 solid;
        margin-bottom: 2rem;
        color: #74b828;
      }
      .about-text {
        color: #74b828;
        margin-bottom: 2.6rem;
      }
      .about-item {
        h1 {
          color: #fff;
          line-height: 3rem;
        }
        p {
          color: #74b828;
          font-size: 1.4rem;
          font-weight: 500;
          line-height: 3rem;
        }
      }
    }
    .about-video {
      padding-top: 8rem;
      padding-left: 3rem;
      flex: 1;
      p {
        color: #fff;
      }
    }
  }
}
@media only screen and (max-width: 786px) {
  .about-qualifications {
    height: 100vh;
    .container {
      max-width: 786px;
      width: 100%;
      padding: 20px 20px;
      flex-direction: column;
      .about-video {
        padding: 1rem 0 0;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>